export const types = {
  uiCollapsedSidebar: "[ui] Collapsed SideBar",
  uiShowForm: "[ui] Show Form",
  uiShowDrawer: "[ui] Show Drawer",
  uiShowModal: "[ui] Show Modal",
  uiLoading: "[ui] Loading",
  uiSetSettingsLayout: "[ui] Set Settings Layout",
  uiSetToggleTheme: "[ui] Set Toggle Theme",
};
